module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.7655/img/cms-free-signup.png"